import React from 'react';
import { Section } from './Section';
import { TrendingUp, ArrowRight, Minus } from 'lucide-react';
export function Transformation() {
  const before = ['Ventas por WhatsApp, Instagram o tienda física', 'Sin tienda online propia', 'Consultas dispersas', 'Poco control comercial', 'Sin medición clara', 'Canal online pendiente o mal construido'];
  const after = ['Tienda online profesional', 'Catálogo ordenado', 'Pagos y pedidos online', 'Mejor presentación comercial', 'Base preparada para campañas, seguimiento y medición', 'Canal online convertido en activo comercial'];
  return <Section className="bg-slate-50" data-id="element-353">
      <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-354">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy-900 mb-4" data-id="element-355">
          De vender de forma manual a tener una base ecommerce profesional
        </h2>
      </div>

      <div className="max-w-5xl mx-auto relative" data-id="element-356">
        {/* Desktop Arrow Connector */}
        <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10 bg-white rounded-full p-4 shadow-xl border border-slate-100" data-id="element-357">
          <ArrowRight className="w-8 h-8 text-accent" data-id="element-358" />
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-359">
          {/* Antes */}
          <div className="bg-white rounded-3xl p-8 md:p-10 border border-slate-200 shadow-sm" data-id="element-360">
            <div className="text-slate-400 font-heading font-bold text-xl mb-6 uppercase tracking-wider" data-id="element-361">
              Antes
            </div>
            <div className="space-y-5" data-id="element-362">
              {before.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-363">
                  <Minus className="w-5 h-5 text-slate-300 shrink-0 mt-0.5" data-id="element-364" />
                  <span className="text-slate-500" data-id="element-365">{item}</span>
                </div>)}
            </div>
          </div>

          {/* Después */}
          <div className="bg-white rounded-3xl p-8 md:p-10 border-2 border-accent/20 shadow-lg relative overflow-hidden" data-id="element-366">
            <div className="absolute inset-0 bg-accent/[0.02]" data-id="element-367"></div>
            <div className="relative" data-id="element-368">
              <div className="text-accent font-heading font-bold text-xl mb-6 uppercase tracking-wider flex items-center gap-2" data-id="element-369">
                Después <TrendingUp className="w-5 h-5" data-id="element-370" />
              </div>
              <div className="space-y-5" data-id="element-371">
                {after.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-372">
                    <div className="w-5 h-5 rounded-full bg-accent/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-373">
                      <div className="w-2 h-2 rounded-full bg-accent" data-id="element-374"></div>
                    </div>
                    <span className="text-navy-900 font-medium" data-id="element-375">{item}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}